import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home';
import { AuthGuard } from './_helpers';
import { Role } from './_models';

import { CandidateentryComponent } from './order/applicant/candidateentry/candidateentry.component';
import { PdftemplateComponent } from './pdftemplate/pdftemplate.component'
import { ForwardComponent } from './forward/forward.component';
import { PdfGenerationService } from './_services';

const accountModule = () => import('./account/account.module').then(x => x.AccountModule);
const adminModule = () => import('./admin/admin.module').then(x => x.AdminModule);
const profileModule = () => import('./profile/profile.module').then(x => x.ProfileModule);
const signupModule = () => import('./signup/signup.module').then(x => x.SignupModule);
const orderModule = () => import('./order/order.module').then(x => x.OrderModule);
const homeModule = () => import ('./home/home.module').then(x => x.HomeModule);
const campaignModule = () => import ('./campaign/campaign.module').then(x => x.CampaignModule);
const partnerModule = () => import ('./partner/partner.module').then(x => x.PartnerModule);
const pdfModule = () => import ('./pdftemplate/pdftemplate.module').then(x => x.PdfModule);

const routes: Routes = [
    { path: 'home', loadChildren: homeModule, canActivate: [AuthGuard] },
    { path: 'account', loadChildren: accountModule },
    { path: 'profile', loadChildren: profileModule, canActivate: [AuthGuard] },
    { path: 'admin', loadChildren: adminModule, canActivate: [AuthGuard], data: { roles: [Role.Admin] } },
    { path: 'signup', loadChildren: signupModule },
    { path: 'order', loadChildren: orderModule },
    { path: 'campaign', loadChildren: campaignModule },
    { path: 'partner', loadChildren: partnerModule },
    { path: 'candidateentry/:token', component: CandidateentryComponent },
    { path: '', redirectTo: '/home', pathMatch: 'full'},
    { path: 'pdf', loadChildren: pdfModule},
    // otherwise redirect to home
    { path: '**', redirectTo: '' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy', scrollPositionRestoration: 'enabled' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
